import { useEffect } from "react"
import { viewSelector } from "../../recoil/atoms/view"
import { RECONNECT_TIMEOUT, Views } from "../../constants"
import { joinButtonLoadingSelector } from "../../recoil/atoms/joinButton"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import {
  handleWebsocketDisconnectSelector,
  pageVisibilityStatus
} from "../../recoil/atoms/wsStatus"
import MOLocation from "../../util/MOLocation"

const useWsReconnection = () => {
  const [webSocketDisconnect, setWebSocketDisconnect] = useRecoilState(
    handleWebsocketDisconnectSelector
  )
  const isSiteActive = useRecoilValue(pageVisibilityStatus)
  const setView = useSetRecoilState(viewSelector)
  const setLoading = useSetRecoilState(joinButtonLoadingSelector)

  useEffect(() => {
    ;(async () => {
      const webSocketDisconnectReason = webSocketDisconnect.reason
      const timeOfWsDisconnect = webSocketDisconnect?.pageInActiveTime
      const timeDifference = (Date.now() - timeOfWsDisconnect) / 1000

      if (
        isSiteActive &&
        timeDifference < RECONNECT_TIMEOUT &&
        webSocketDisconnectReason !== -1
      ) {
        const meetingClient = window.MeetOnline.client()
        if (!meetingClient?.isWebSocketOpen()) {
          setLoading(true)
          setView(Views.HOME)
          try {
            await meetingClient?.connectGateway()
          } catch (error) {
            MOLocation.reload()
          }
        }

        setWebSocketDisconnect({ reason: -1 })
      } 
    })()
  }, [
    webSocketDisconnect,
    isSiteActive,
    setWebSocketDisconnect,
    setView,
    setLoading
  ])
}

export default useWsReconnection
